import * as firebase from 'firebase/app'

import 'firebase/firestore'
import 'firebase/auth'
import 'firebase/functions'

import config from '../firebase.config.js'

import store from '@/store.js'

import { FUNCTIONS_URL } from '@/constants.js'

const app = firebase.initializeApp(config)
const firestore = app.firestore()
const auth = app.auth()
const functions = app.functions('europe-west1')

const initialize = () => {
  return new Promise((resolve, reject) => {
    auth.onAuthStateChanged((user) => {
      if (user) {
        store.dispatch('bindClublinks', { userId: user.uid })
      } else {
        store.dispatch('unbindClublinks')
      }
      resolve()
    })
  })
}

const signIn = () => {
  return new Promise((resolve, reject) => {
    if (store.state.isConnected) {
      return resolve()
    }

    store.commit('signIn', true)
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        store.commit('signIn', false)
        unsubscribe()
        resolve()
      }
    })

    window.open(new URL(`${FUNCTIONS_URL}/redirectManiaplanet`), 'Sign In', 'width=450,height=750')
  })
}

const signOut = () => {
  return new Promise(async (resolve, reject) => {
    store.commit('signOut', true)
    await auth.signOut()
    store.commit('signOut', false)
    resolve()
  })
}

auth.onAuthStateChanged((user) => {
  if (user) {
    store.commit('isConnected', true)
  } else {
    store.commit('isConnected', false)
  }
})

export { firestore, auth, functions, initialize, signIn, signOut }
